import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto px-8 flex flex-row md:items-center md:justify-center h-screen mt-8 md:mt-0" }
const _hoisted_2 = { class: "w-full md:w-2/3 mx-auto flex flex-col space-y-8" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 md:gap-x-8 gap-y-4 md:gap-y-8" }

import InputText from "@/components/Form/InputText.vue";
import { computed, ref } from "vue";
import ButtonBase from "@/components/Buttons/ButtonPrimary.vue";
import { useAuthStore } from "@/store/useAuthStore";
import TextError from "@/components/Texts/TextError.vue";
import { useErrorsStore } from "@/store/useErrorsStore";
import RouterLinkCustom from "@/components/Texts/RouterLinkCustom.vue";
import TitleBig from "@/components/Titles/TitleBig.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const authStore = useAuthStore();
const errorsStore = useErrorsStore();

const nameValue = ref("");
const passwordValue = ref("");

const tryLogin = () => {
  authStore.loginUser(nameValue.value, passwordValue.value);
};

const errorMessage = computed(() => {
  const errorInput = errorsStore.getErrorByName("login");
  if (errorInput) {
    return errorInput.message;
  }
  return "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TitleBig, { text: "Login" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InputText, {
          name: "name",
          is_required: true,
          id: "name",
          modelValue: nameValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nameValue).value = $event)),
          placeholder: "Name",
          type: "text"
        }, null, 8, ["modelValue"]),
        _createVNode(InputText, {
          name: "password",
          is_required: true,
          id: "password",
          modelValue: passwordValue.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordValue).value = $event)),
          placeholder: "Password",
          type: "password"
        }, null, 8, ["modelValue"])
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(TextError, {
            key: 0,
            text: errorMessage.value
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      _createVNode(ButtonBase, {
        class: "w-1/2 md:w-1/4 m-auto md:m-0",
        text: "Sign in",
        onClick: tryLogin
      }),
      _createVNode(RouterLinkCustom, {
        to: "/register",
        text: "Not yet registered ?"
      })
    ])
  ]))
}
}

})